import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { deepExtract } from 'helpers/deep';
import { isPresent } from 'helpers/verify';
var TOGGLE_FILTER_COLLAPSE = 'classpass/filters/TOGGLE_FILTER_COLLAPSE';
var SET_CLEAN = 'classpass/filters/SET_CLEAN';
var RESET_NEEDS_UPDATE = 'classpass/filters/RESET_NEEDS_UPDATE';
var SET_FILTERS_EDITING = 'classpass/filters/SET_FILTERS_EDITING';
var ADD_FILTER = 'classpass/filters/ADD_FILTER';
var CLEAR_FILTER = 'classpass/filters/CLEAR_FILTER';
var CLEAR_FILTERS = 'classpass/filters/CLEAR_FILTERS';
var TOGGLE_ITEM_ID = 'classpass/filters/TOGGLE_ITEM_ID';
var TOGGLE_FILTER_PARENT_COLLAPSE = 'classpass/filters/TOGGLE_FILTER_PARENT_COLLAPSE';
var SET_FILTER_VALUE = 'classpass/filters/SET_FILTER_VALUE';
var SET_ITEM_ID_SELECTED = 'classpass/filters/SET_ITEM_ID_SELECTED';
export var FILTER_WRITE_ACTIONS = [CLEAR_FILTER, CLEAR_FILTERS, TOGGLE_ITEM_ID, SET_FILTER_VALUE, SET_ITEM_ID_SELECTED];

var toggleFilterCollapse = function toggleFilterCollapse(filterSetId, filter) {
  return {
    type: TOGGLE_FILTER_COLLAPSE,
    data: {
      filterSetId: filterSetId,
      filter: filter
    }
  };
};

var setMultipleFiltersEditing = function setMultipleFiltersEditing(filterSetId, filters, isEditing) {
  return {
    type: SET_FILTERS_EDITING,
    data: {
      filterSetId: filterSetId,
      filters: filters,
      isEditing: isEditing
    }
  };
};

var setFilterEditing = function setFilterEditing(filterSetId, filter, isEditing) {
  return setMultipleFiltersEditing(filterSetId, [filter], isEditing);
};

var addFilter = function addFilter(filterSetId, filter, items, relationships, options) {
  return {
    type: ADD_FILTER,
    data: {
      filterSetId: filterSetId,
      filter: filter,
      items: items,
      relationships: relationships,
      options: options
    }
  };
};

var setClean = function setClean(filterSetId) {
  return {
    type: SET_CLEAN,
    data: {
      filterSetId: filterSetId
    }
  };
};

var resetNeedsUpdate = function resetNeedsUpdate(filterSetId, filters) {
  return {
    type: RESET_NEEDS_UPDATE,
    data: {
      filterSetId: filterSetId,
      filters: filters
    }
  };
};

var clearFilter = function clearFilter(filterSetId, filter, filtersToOmit) {
  return {
    type: CLEAR_FILTER,
    data: {
      filterSetId: filterSetId,
      filter: filter,
      filtersToOmit: filtersToOmit
    }
  };
};

var clearMultipleFilters = function clearMultipleFilters(filterSetId, filters) {
  return {
    type: CLEAR_FILTERS,
    data: {
      filterSetId: filterSetId,
      filters: filters
    }
  };
};

var clearFilterSet = function clearFilterSet(filterSetId, filtersToOmit) {
  return clearFilter(filterSetId, null, filtersToOmit);
};

var toggleItemId = function toggleItemId(filterSetId, filter) {
  for (var _len = arguments.length, itemIds = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    itemIds[_key - 2] = arguments[_key];
  }

  return {
    type: TOGGLE_ITEM_ID,
    data: {
      filterSetId: filterSetId,
      filter: filter,
      itemIds: itemIds
    }
  };
};

var toggleItemIdWithoutUpdate = function toggleItemIdWithoutUpdate(filterSetId, filter) {
  for (var _len2 = arguments.length, itemIds = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    itemIds[_key2 - 2] = arguments[_key2];
  }

  return {
    type: TOGGLE_ITEM_ID,
    data: {
      filterSetId: filterSetId,
      filter: filter,
      itemIds: itemIds,
      options: {
        excludeFromWriteActions: true
      }
    }
  };
};

var setItemIdSelected = function setItemIdSelected(filterSetId, filter) {
  for (var _len3 = arguments.length, itemIds = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    itemIds[_key3 - 2] = arguments[_key3];
  }

  return {
    type: SET_ITEM_ID_SELECTED,
    data: {
      filterSetId: filterSetId,
      filter: filter,
      itemIds: itemIds
    }
  };
};

var setFilterValue = function setFilterValue(filterSetId, filter, value, options) {
  return {
    type: SET_FILTER_VALUE,
    data: {
      filterSetId: filterSetId,
      filter: filter,
      value: value,
      options: options
    }
  };
};

var toggleFilterParentCollapse = function toggleFilterParentCollapse(filterSetId, filter, itemId) {
  return {
    type: TOGGLE_FILTER_PARENT_COLLAPSE,
    data: {
      filterSetId: filterSetId,
      filter: filter,
      itemId: itemId
    }
  };
};

export var actionsForFilterSet = function actionsForFilterSet(filterSetId) {
  return {
    filterSet: filterSetId,
    toggleFilterCollapse: toggleFilterCollapse.bind(null, filterSetId),
    setMultipleFiltersEditing: setMultipleFiltersEditing.bind(null, filterSetId),
    setFilterEditing: setFilterEditing.bind(null, filterSetId),
    addFilter: addFilter.bind(null, filterSetId),
    setClean: setClean.bind(null, filterSetId),
    resetNeedsUpdate: resetNeedsUpdate.bind(null, filterSetId),
    clearFilter: clearFilter.bind(null, filterSetId),
    clearMultipleFilters: clearMultipleFilters.bind(null, filterSetId),
    clearFilterSet: clearFilterSet.bind(null, filterSetId),
    toggleItemId: toggleItemId.bind(null, filterSetId),
    toggleItemIdWithoutUpdate: toggleItemIdWithoutUpdate.bind(null, filterSetId),
    setItemIdSelected: setItemIdSelected.bind(null, filterSetId),
    setFilterValue: setFilterValue.bind(null, filterSetId),
    toggleFilterParentCollapse: toggleFilterParentCollapse.bind(null, filterSetId)
  };
};
var initialState = {};
var initialFilterSetState = {
  filters: {},
  dirty: false,
  filtered: false
};
var initialFilterState = {
  itemsById: {},
  parentedItemIds: {},
  countSelected: 0,
  itemIdSelected: {},
  parentIdPartialSelected: {},
  parentIdExpanded: {},
  expanded: false,
  filtered: false,
  needsUpdate: false,
  isEditing: false
};

var recursivelyGetChildIds = function recursivelyGetChildIds(map, start) {
  return map[start].reduce(function (children, child) {
    return children.concat(map[child] ? recursivelyGetChildIds(map, child) : [child]);
  }, []);
};

var calculateParentStates = function calculateParentStates(parentMap, itemIdSelected) {
  return Object.keys(parentMap).filter(function (parent) {
    return parent !== '0' && parent !== 'root';
  }).reduce(function (memo, parentId) {
    var childIds = recursivelyGetChildIds(parentMap, parentId);

    if (childIds.some(function (child) {
      return itemIdSelected[child];
    })) {
      memo.parentIdPartialSelected[parentId] = true;
    }

    return memo;
  }, {
    parentIdPartialSelected: {}
  });
};

var filtered = function filtered(filter) {
  return !!Object.keys(filter.itemIdSelected || {}).length || !!filter.isValueFilter && isPresent(filter.value) && filter.value !== filter.unfilteredValue;
};

var filteredSet = function filteredSet(filters) {
  return Object.keys(filters || {}).some(function (filter) {
    return filters[filter].filtered;
  });
};

var setFilterFilteredFlag = function setFilterFilteredFlag(filter, state) {
  return _objectSpread({}, state, _defineProperty({}, filter, _objectSpread({}, state[filter], {
    filtered: filtered(state[filter])
  })));
};

var setFilterSetFilteredFlag = function setFilterSetFilteredFlag(filterSetId, state) {
  return _objectSpread({}, state, _defineProperty({}, filterSetId, _objectSpread({}, state[filterSetId], {
    filtered: filteredSet(state[filterSetId].filters)
  })));
};

export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = action.data || {},
      _ref$filtersToOmit = _ref.filtersToOmit,
      filtersToOmit = _ref$filtersToOmit === void 0 ? [] : _ref$filtersToOmit,
      filterSetId = _ref.filterSetId,
      filter = _ref.filter,
      filters = _ref.filters,
      itemId = _ref.itemId,
      itemIds = _ref.itemIds,
      options = _ref.options,
      value = _ref.value;

  switch (action.type) {
    // TODO: Split up filter creator to have creators for different types of filters and avoid extra fields polluting fitler data
    case ADD_FILTER:
      return _objectSpread({}, state, _defineProperty({}, filterSetId, _objectSpread({}, state[filterSetId] || initialFilterSetState, {
        filters: _objectSpread({}, setFilterFilteredFlag(filter, _objectSpread({}, state[filterSetId] ? state[filterSetId].filters : {}, _defineProperty({}, filter, _objectSpread({}, initialFilterState, state[filterSetId] ? state[filterSetId].filters[filter] : {}, {
          exclusive: options && options.exclusive,
          filterable: options && options.filterable,
          isValueFilter: options && options.valueFilter,
          name: options && options.name,
          value: options && options.value,
          unfilteredValue: options && options.unfilteredValue,
          // used as indicator for "filtered" flag if there is a value that represents an "unfiltered" state
          itemIdSelected: options && !options.exclusive && options.selected || {},
          countSelected: options && Object.keys(options.selected || {}).length,
          itemsById: action.data.items.reduce(function (memo, item) {
            return _objectSpread({}, memo, _defineProperty({}, item.id, item));
          }, {}),
          orderedItemIds: action.data.items.map(function (item) {
            return item.id;
          }),
          parentedItemIds: action.data.relationships ? action.data.relationships : {
            root: action.data.items.map(function (item) {
              return item.id;
            })
          }
        })))))
      })));

    case SET_FILTER_VALUE:
      return setFilterSetFilteredFlag(filterSetId, _objectSpread({}, state, _defineProperty({}, filterSetId, _objectSpread({}, state[filterSetId], {
        dirty: true,
        filters: _objectSpread({}, setFilterFilteredFlag(filter, _objectSpread({}, state[filterSetId].filters, _defineProperty({}, filter, _objectSpread({}, state[filterSetId].filters[filter], {
          value: value,
          dirty: true,
          needsUpdate: true,
          isEditing: action.data.options && action.data.options.resetIsEditing ? false : state[filterSetId].filters[filter].isEditing
        })))))
      }))));

    case SET_ITEM_ID_SELECTED:
      {
        var itemIdSelected = itemIds.reduce(function (object, id) {
          object[id] = true;
          return object;
        }, {});
        return setFilterSetFilteredFlag(filterSetId, _objectSpread({}, state, _defineProperty({}, filterSetId, _objectSpread({}, state[filterSetId], {
          dirty: true,
          filters: _objectSpread({}, setFilterFilteredFlag(filter, _objectSpread({}, state[filterSetId].filters, _defineProperty({}, filter, _objectSpread({}, state[filterSetId].filters[filter], {
            itemIdSelected: itemIdSelected,
            countSelected: Object.keys(itemIdSelected).length
          }, calculateParentStates(state[filterSetId].filters[filter].parentedItemIds, itemIdSelected))))))
        }))));
      }

    case TOGGLE_FILTER_COLLAPSE:
      return _objectSpread({}, state, _defineProperty({}, filterSetId, _objectSpread({}, state[filterSetId], {
        filters: Object.keys(state[filterSetId].filters).reduce(function (set, thisFilterId) {
          var existingExpandedStatus = state[filterSetId].filters[thisFilterId].expanded;
          var nextExpandedStatus = !existingExpandedStatus;
          return _objectSpread({}, set, _defineProperty({}, thisFilterId, _objectSpread({}, state[filterSetId].filters[thisFilterId], {
            expanded: !filter || thisFilterId === filter ? nextExpandedStatus : existingExpandedStatus
          })));
        }, {})
      })));

    case SET_FILTERS_EDITING:
      return _objectSpread({}, state, _defineProperty({}, filterSetId, _objectSpread({}, state[filterSetId], {
        filters: _objectSpread({}, state[filterSetId].filters, filters.reduce(function (filterAccumulator, filterName) {
          return _objectSpread({}, filterAccumulator, _defineProperty({}, filterName, _objectSpread({}, state[filterSetId].filters[filterName], {
            isEditing: filters.includes(filterName) ? action.data.isEditing : state[filterSetId].filters[filterName].isEditing
          })));
        }, {}))
      })));

    case SET_CLEAN:
      return _objectSpread({}, state, _defineProperty({}, filterSetId, _objectSpread({}, state[filterSetId], {
        dirty: false
      })));

    case RESET_NEEDS_UPDATE:
      return _objectSpread({}, state, _defineProperty({}, filterSetId, _objectSpread({}, state[filterSetId], {
        filters: _objectSpread({}, state[filterSetId].filters, filters.reduce(function (set, filterName) {
          return _objectSpread({}, set, _defineProperty({}, filterName, _objectSpread({}, state[filterSetId].filters[filterName], {
            needsUpdate: false
          })));
        }, {}))
      })));

    case CLEAR_FILTER:
      return setFilterSetFilteredFlag(filterSetId, _objectSpread({}, state, _defineProperty({}, filterSetId, _objectSpread({}, state[filterSetId], {
        dirty: true,
        filters: Object.keys(deepExtract("".concat(filterSetId, ".filters"), state, {})).reduce(function (set, thisFilterId) {
          return _objectSpread({}, setFilterFilteredFlag(thisFilterId, _objectSpread({}, set, _defineProperty({}, thisFilterId, _objectSpread({}, state[filterSetId].filters[thisFilterId], // Clears the current filter IF
          (!filter || // If no filter (eg when clearFilterSet called, thus clearing all filters)
          thisFilterId === filter // OR if the filter being cleared matches the current filter
          ) && // BUT don't clear any filters that are intentionally omitted
          !filtersToOmit.includes(thisFilterId) ? {
            countSelected: 0,
            itemIdSelected: {},
            parentIdPartialSelected: {},
            value: null
          } : {})))));
        }, {})
      }))));

    case CLEAR_FILTERS:
      return setFilterSetFilteredFlag(filterSetId, _objectSpread({}, state, _defineProperty({}, filterSetId, _objectSpread({}, state[filterSetId], {
        dirty: true,
        filters: Object.keys(deepExtract("".concat(filterSetId, ".filters"), state, {})).reduce(function (set, thisFilterId) {
          return _objectSpread({}, setFilterFilteredFlag(thisFilterId, _objectSpread({}, set, _defineProperty({}, thisFilterId, _objectSpread({}, state[filterSetId].filters[thisFilterId], // Clears the current filter IF
          filters.includes(thisFilterId) ? {
            countSelected: 0,
            itemIdSelected: {},
            parentIdPartialSelected: {},
            value: null
          } : {})))));
        }, {})
      }))));

    case TOGGLE_ITEM_ID:
      {
        var currentFilterData = state[filterSetId].filters[filter];

        var _itemIdSelected = _objectSpread({}, currentFilterData.itemIdSelected);

        itemIds.forEach(function (thisItemId) {
          if (currentFilterData.exclusive) {
            _itemIdSelected = _defineProperty({}, thisItemId, true);
          } else if (currentFilterData.parentedItemIds[thisItemId]) {
            // Clicked Parent
            // Parent was selected, deselect it.
            if (_itemIdSelected[thisItemId]) {
              delete _itemIdSelected[thisItemId]; // Parent was not selected/partially selected, deselect all children & select parent.
            } else {
              recursivelyGetChildIds(currentFilterData.parentedItemIds, thisItemId).forEach(function (item) {
                return delete _itemIdSelected[item];
              });
              _itemIdSelected[thisItemId] = true;
            } // Clicked selected child, deselect it.

          } else if (_itemIdSelected[thisItemId]) {
            delete _itemIdSelected[thisItemId]; // Clicked deselected child, select it & deselect parent if it's selected.
          } else {
            var parentId = currentFilterData.itemsById[thisItemId].parent_id;

            if (_itemIdSelected[parentId]) {
              delete _itemIdSelected[parentId];
            }

            _itemIdSelected[thisItemId] = true;
          }
        });
        return setFilterSetFilteredFlag(filterSetId, _objectSpread({}, state, _defineProperty({}, filterSetId, _objectSpread({}, state[filterSetId], {
          dirty: true,
          filters: _objectSpread({}, setFilterFilteredFlag(filter, _objectSpread({}, state[filterSetId].filters, _defineProperty({}, filter, _objectSpread({}, state[filterSetId].filters[filter], {
            itemIdSelected: _itemIdSelected,
            needsUpdate: true,
            countSelected: Object.keys(_itemIdSelected).length
          }, calculateParentStates(state[filterSetId].filters[filter].parentedItemIds, _itemIdSelected))))))
        }))));
      }

    case TOGGLE_FILTER_PARENT_COLLAPSE:
      {
        var parentIdExpanded = _objectSpread({}, state[filterSetId].filters[filter].parentIdExpanded);

        if (parentIdExpanded[itemId]) {
          delete parentIdExpanded[itemId];
        } else {
          parentIdExpanded[itemId] = true;
        }

        return setFilterSetFilteredFlag(filterSetId, _objectSpread({}, state, _defineProperty({}, filterSetId, _objectSpread({}, state[filterSetId], {
          dirty: true,
          filters: _objectSpread({}, setFilterFilteredFlag(filter, _objectSpread({}, state[filterSetId].filters, _defineProperty({}, filter, _objectSpread({}, state[filterSetId].filters[filter], {
            parentIdExpanded: parentIdExpanded
          })))))
        }))));
      }

    default:
      return state;
  }
}